import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../constants";
import { GetServiceCaller } from "../../../services/serviceCaller";
import moment from "moment";
import awardLeader from "../../../assets/awardleader.png";
import badge2position from "../../../assets/badge2position.png";
import badge1position from "../../../assets/badge1position.png";
import badge3position from "../../../assets/badge3position.png";
import { FaSpinner } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import maleCandidate from "../../../assets/maleCandidate.jpg";
import awardLabel from "../../../assets/Achievers Leaderboard.svg";
import awardTropy from "../../../assets/Achiever_trophy.svg";
import filterImg from "../../../assets/Achiever_Filer.svg";
import ImageModal from "../../../modules/Dashboard/DashboardComponent/ImageModalComponent/ImageModalComponent";
 
const Achievers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(updateNavbarHeading("Achievers"));
  }, []);
 
  const [achiever, setAchiever] = useState([]);
  const [tweleMonth, setTweleMonth] = useState([]);
  const [threeMonthData, setThreeMonthData] = useState([]);
  const [sixMonthData, setSixMonthData] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [modalImage, setModalImage] = useState(null);
  const [allAchievers, setAllAchievers] = useState([]); // original API data
  const [searchTerm, setSearchTerm] = useState("");
 
  const handleImageClick = useCallback((imageUrl) => {
    setModalImage(imageUrl);
  }, []);
 
  const closeModal = useCallback(() => {
    setModalImage(null);
  }, []);
 
  const fetchForthComingDetails = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}nest/dashboard/empAchivers`);
      //Achievers data
      const empAchieverData = response?.data?.empAchievers || [];
     
      // Debug: Check for duplicates
      if (empAchieverData) {
        const duplicateIds = empAchieverData
          .map(item => item.ID)
          .filter((id, index, arr) => arr.indexOf(id) !== index);
       
        if (duplicateIds.length > 0) {
          console.warn('Duplicate IDs from API:', duplicateIds);
        }
      }
 
      setAchiever(empAchieverData);
      setAllAchievers(empAchieverData); // store full data
      // 12 months data
      const tweleMonth = response?.data?.leaderboard || [];
      setTweleMonth(tweleMonth);
 
      // 3 months data
      const threeMonth = response?.data?.TopAchieversThirdMonth || [];
      setThreeMonthData(threeMonth);
 
      // 6 Months Data
      const sixMonth = response?.data?.TopAchieversSixthMonth || [];
      setSixMonthData(sixMonth);
      setPageLoading(false);
    } catch (error) {
      console.error("Error fetching ForthComing Details:", error);
      setPageLoading(false);
    }
  };
 
  useEffect(() => {
    fetchForthComingDetails();
  }, []);
 
  const handleViewMore = () => {
    navigate("/achievers/leaderboard");
  };
 
  const sortedWinners = [...tweleMonth].sort((a, b) => a.rank - b.rank);
 
  // Get winners in desired order: 2nd, 1st, 3rd
  const winnersDisplayOrder = [
    sortedWinners.find((winner) => winner.rank === 2),
    sortedWinners.find((winner) => winner.rank === 1),
    sortedWinners.find((winner) => winner.rank === 3),
  ];
 
  const getBadge = (rank) => {
    switch (rank) {
      case 1:
        return badge1position;
      case 2:
        return badge2position;
      case 3:
        return badge3position;
      default:
        return null;
    }
  };
 
  const sortedthreeWinners = [...threeMonthData].sort(
    (a, b) => a.rank - b.rank
  );
 
  // Get winners in desired order: 2nd, 1st, 3rd
  const winnersthreeDisplayOrder = [
    sortedthreeWinners.find((item) => item.rank === 2),
    sortedthreeWinners.find((item) => item.rank === 1),
    sortedthreeWinners.find((item) => item.rank === 3),
  ];
 
  const getthreeBadge = (rank) => {
    switch (rank) {
      case 1:
        return badge1position;
      case 2:
        return badge2position;
      case 3:
        return badge3position;
      default:
        return null;
    }
  };
 
  const sortedsixWinners = [...sixMonthData].sort((a, b) => a.rank - b.rank);
 
  // Get winners in desired order: 2nd, 1st, 3rd
  const winnersSixDisplayOrder = [
    sortedsixWinners.find((item) => item.rank === 2),
    sortedsixWinners.find((item) => item.rank === 1),
    sortedsixWinners.find((item) => item.rank === 3),
  ];
 
  const getSixBadge = (rank) => {
    switch (rank) {
      case 1:
        return badge1position;
      case 2:
        return badge2position;
      case 3:
        return badge3position;
      default:
        return null;
    }
  };
 

const handleSearch = (e) => {
  const term = e.target.value.toLowerCase();
  setSearchTerm(e.target.value); 
 
  if (!term.trim()) {
    setAchiever(allAchievers);
    return;
  }
 
  const filtered = allAchievers.filter((item) => {
    const title = item?.title?.toLowerCase() || '';
    const name = item?.Name?.toLowerCase() || '';
 
 
    let awardText = '';
    if (item?.Message) {
      const match = item.Message.match(/<b>\\?"?(.*?)\\?"?<\/b>/);
      if (match && match[1]) {
        awardText = match[1].toLowerCase();
      }
    }
 
    return (
      title.includes(term) ||
      name.includes(term) ||
      awardText.includes(term)
    );
  });
 
  setAchiever(filtered);
};
 
  if (pageLoading) {
    return (
      <div className="position-absolute top-50 start-50 translate-middle text-center">
        <FaSpinner className="spinner" />
      </div>
    );
  }
 
  return (
    <div className="container-fluid" id="skill_section" style={{ height: "100vh" }}>
      <div className="row g-2">
        <div className="col-lg-7">
          <div className="container-fluid p-2" id="achievers_section_award">
            <button
              type="button"
              className="view-more"
              onClick={() => handleViewMore()}
              style={{ zIndex: 1, position: 'relative' }}
            >
              View More
            </button>
            <div className="text-center">
              <img src={awardLabel} alt="Label" />
            </div>
 
            <div className="leaderboard-content mt-1">
              <div className="empTrp">
                <img src={awardTropy} className="award-trohy" />
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <div className="time-filter">LAST 12 MONTHS</div>
              </div>
              <div className="winners-container d-flex flex-column flex-md-row justify-content-center align-items-center gap-2">
                {winnersDisplayOrder.map(
                  (winner, index) =>
                    winner && (
                      <div
                        key={`${winner.EmployeeID}-${winner.rank}-${index}`}
                        className={`winner-card ${
                          index === 2 ? "third-place" : ""
                        }`}
                      >
                        <div className="medal-container">
                          <div className="medal-container-rank">
                            <img
                              src={getBadge(winner.rank)}
                              alt={`Badge ${winner.rank}`}
                              onClick={() =>
                                winner.FilePath &&
                                handleImageClick(winner.FilePath)
                              }
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        </div>
                        <img
                          src={winner.FilePath}
                          alt={winner.Name}
                          className="rank-image"
                          onClick={() =>
                            winner.FilePath && handleImageClick(winner.FilePath)
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <div className="winner-name">{winner.Name || ""}</div>
                        <div className="winner-score">{winner.score || ""}</div>
                      </div>
                    )
                )}
              </div>
              <div className="d-flex justify-content-between align-items-center mt-2 achiever-container d-none d-xxl-block">
                <div className="time-filter">LAST 06 MONTHS</div>
              </div>
              <div className="winners-container d-flex justify-content-center gap-2 achiever-container d-none d-xxl-flex">
                {winnersSixDisplayOrder.map(
                  (winner, index) =>
                    winner && (
                      <div
                        key={`${winner.EmployeeID}-${winner.rank}-${index}`}
                        className={`winner-card ${
                          index === 2 ? "third-place" : ""
                        }`}
                      >
                        <div className="medal-container">
                          <div className="medal-container-rank">
                            <img
                              src={getSixBadge(winner.rank)}
                              alt={`Badge ${winner.rank}`}
                              onClick={() =>
                                winner.FilePath &&
                                handleImageClick(winner.FilePath)
                              }
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        </div>
                        <img
                          src={winner.FilePath}
                          alt={winner.Name}
                          className="rank-image"
                          onClick={() =>
                            winner.FilePath && handleImageClick(winner.FilePath)
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <div className="winner-name">{winner.Name || ""}</div>
                        <div className="winner-score">{winner.score || ""}</div>
                      </div>
                    )
                )}
              </div>
              <div className="d-flex justify-content-between align-items-center mt-2">
                <div className="time-filter">LAST 03 MONTHS</div>
              </div>
              <div className="winners-container d-flex flex-column flex-md-row justify-content-center align-items-center gap-2">
                {winnersthreeDisplayOrder.map(
                  (winner, index) =>
                    winner && (
                      <div
                        key={`${winner.EmployeeID}-${winner.rank}-${index}`}
                        className={`winner-card ${
                          index === 2 ? "third-place" : ""
                        }`}
                      >
                        <div className="medal-container">
                          <div className="medal-container-rank">
                            <img
                              src={getthreeBadge(winner.rank)}
                              alt={`Badge ${winner.rank}`}
                              onClick={() =>
                                winner.FilePath &&
                                handleImageClick(winner.FilePath)
                              }
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        </div>
                        <img
                          src={winner.FilePath}
                          alt={winner.Name}
                          className="rank-image"
                          onClick={() =>
                            winner.FilePath && handleImageClick(winner.FilePath)
                          }
                          style={{ cursor: "pointer" }}
                        />
                        <div className="winner-name">{winner.Name || ""}</div>
                        <div className="winner-score">{winner.score || ""}</div>
                      </div>
                    )
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-5">
          <div className="container-fluid" id="achievers_section">
            {/* 🔍 Fixed Search Input */}
           <div className="text-center mb-2 px-3">
              <h5
                className="text-uppercase fw-semibold text-secondary mb-1"
                style={{ letterSpacing: '1px', fontSize: '1.1rem' }}
              >
                Achievers Highlights — Last 12 Months
              </h5>
 
              <div className="text-center">
                <input
                  type="text"
                  className="form-control mx-auto shadow-sm"
                  style={{
                    maxWidth: '300px',   // 👈 smaller width
                    width: '100%',
                    borderRadius: '10px',
                    padding: '0.6rem 1rem',
                    fontSize: '0.95rem',
                    height: '35px'
                  }}
                  placeholder="Quick Search: Employee / Award"
                  value={searchTerm}
                  onChange={handleSearch}
                />
              </div>
            </div>
 
            <div>
              {achiever?.length > 0 ? (
                achiever?.map((item, index) => (
                  <div key={`${item.ID}-${index}`} className="forthcoming-container">
                    <div className="forthcoming-profile-section">
                      <div className="emp-award-img">
                        <img
                          src={item.ProfileImage}
                          alt="Image"
                          className="achiever-emp-img"
                          onClick={() => handleImageClick(item.ProfileImage)}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                      <div className="name-section">
                        <h1 className="name">
                          {item.title || ""}{" "}
                          <span style={{ color: "#9D9D9D", fontWeight: "500" }}>
                            |
                          </span>{" "}
                          <span
                            style={{
                              fontSize: "10px",
                              color: "#9D9D9D",
                              fontWeight: "500",
                            }}
                          >
                            {moment(item.Date).format("DD MMM YYYY")}
                          </span>
                        </h1>
                        <p
                          className="status"
                          style={{ whiteSpace: "pre-line" }}
                        >
                          {item.Message?.replace(/<b>/g, "<strong>")
                            ?.replace(/<\/b>/g, "</strong>")
                            ?.replace(/<br\/>/g, "")
                            ?.replace(/Posted by:/, "\nPosted by:")
                            ?.split(/(<strong>.*?<\/strong>)/)
                            ?.map((part, index) => {
                              if (
                                part.startsWith("<strong>") &&
                                part.endsWith("</strong>")
                              ) {
                                const content = part.replace(
                                  /<strong>|<\/strong>/g,
                                  ""
                                );
                                return <strong key={index}>{content}</strong>;
                              }
                              return part;
                            })}
                        </p>
                      </div>
                    </div>
                    <div>
                      <img
                        src={item.AwardIcon}
                        alt="Award Icon"
                        className="cake-icon"
                        onClick={() =>
                          item.AwardIcon && handleImageClick(item.AwardIcon)
                        }
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </div>
                ))
              ) : (
                 <div className="text-center p-4">
                    <h6 className="mt-3 text-muted">No achievers found</h6>
                    <p style={{ fontSize: "13px", color: "#9d9d9d" }}>
                      Try searching with a different name or keyword.
                    </p>
                  </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <ImageModal
        isOpen={!!modalImage}
        imageUrl={modalImage}
        onClose={closeModal}
      />
    </div>
  );
};
 
export default Achievers;